import { clsx, type ClassValue } from 'clsx';

/**
 * Utility function for conditionally constructing className strings.
 * This is an alias for clsx that provides a shorter, more common name.
 */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
